import React from 'react';
import './Loader.scss';

export default () => <div className="onboarding-loader" />;
